<template>
    <div class="vue-vehicle-slider">
        <hooper ref="hooper" :settings="hooperSettings">
            <slide v-for="(vehicle, index) in vehicles" :index="index" :key="vehicle.id"
                   :class="{'selected-vehicle': selectedVehicle.id === vehicle.id}">
                <aut-slider-teaser
                    @vehicle-clicked="handleClickSlide(index, vehicle)"
                    :vehicle-data="vehicle"
                    :active-vehicle="selectedVehicle.id === vehicle.id"
                    :is-business="isBusiness"
                ></aut-slider-teaser>
            </slide>
        </hooper>
    </div>
</template>

<script>
import {Hooper, Slide} from 'hooper';
import 'hooper/dist/hooper.css';
import SliderTeaser from "./SliderTeaser.vue";

export default {
    name: "Slider",

    props: ['vehicles', 'selectedVehicle', 'isBusiness'],

    components: {
        Hooper,
        Slide,
        'aut-slider-teaser': SliderTeaser,
    },

    data() {
        return {
            hooperSettings: {
                wheelControl: false,
                breakpoints: {
                    1380: {
                        itemsToShow: 9,
                    },
                    768: {
                        itemsToShow: 6,
                    },
                    0: {
                        itemsToShow: 3.5,
                    }
                }
            }
        }
    },

    methods: {
        handleClickSlide(index, vehicle) {
            //this.$refs.hooper.slideTo(index)
            this.$emit('vehicle-clicked', vehicle)
        }
    },
}
</script>